import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import AutoSuggest from 'react-autosuggest';

const IcdSuggestion = icdCode => (
	<a href="#">
		<strong>{icdCode.icd_code}</strong><br />{icdCode.icd_code_description}
	</a>
);

const ProcedureSuggestion = procedure => (
	<a href="#">
		<strong>{procedure.procedure_code}</strong><br />{procedure.procedure_code_description}
	</a>
);

export default class BillingForm extends React.Component {
	static propTypes = {
		onClose: PropTypes.func.isRequired,
		onSave: PropTypes.func.isRequired,
		evisitId: PropTypes.number.isRequired
	}

	constructor(props) {
		super(props);
		this.state = {
			icdSuggestions: [],
			icdValue: '',
			procedureSuggestions: [],
			procedureValue: ''
		};
	}

	handleICDCodeSuggestionsFetchRequested = ({ value }) => {
		axios.get('/icd_codes', {
			params: {
				filter: JSON.stringify({
					where: {
						or: [
							{ icd_code: { like: `%${value}%`, 'options': 'i' } },
							{ icd_code_description: { like: `%${value}%`, 'options': 'i' } },
							{ icd_code_stripped: { like: `%${value}%`, 'options': 'i' } }
						]
					},
					order: ['default_ordering', 'icd_code'],
					limit: 15
				})
			}
		}).then(({ data }) => this.setState({ icdSuggestions: data }));
	}

	handleICDCodeSelected = (event, { suggestion }) => {
		event.preventDefault();
		this.setState({
			selectedICDCode: suggestion
		});
	}

	handleICDCodeChange = (event, { newValue }) => {
		this.setState({
			icdValue: newValue
		});
	}

	handleProcedureCodeSuggestionsFetchRequested = ({ value }) => {
		axios.get('/procedure_codes', {
			params: {
				filter: JSON.stringify({
					where: {
						or: [
							{ procedure_code: { like: `%${value}%`, 'options': 'i' } },
							{ procedure_code_description: { like: `%${value}%`, 'options': 'i' } }
						]
					},
					order: ['procedure_code'],
					limit: 15
				})
			}
		}).then(({ data }) => this.setState({ procedureSuggestions: data }));
	}

	handleProcedureCodeSelected = (event, { suggestion }) => {
		event.preventDefault();
		this.setState({
			selectedProcedureCode: suggestion
		});
	}

	handleProcedureCodeChange = (event, { newValue }) => {
		this.setState({
			procedureValue: newValue
		});
	}

	handleSave = () => {
		const { evisitId } = this.props;
		const { selectedICDCode, selectedProcedureCode } = this.state;

		const diagnosis = {
			procedure_code_id: selectedProcedureCode ? selectedProcedureCode.id : null,
			icd_code_id: selectedICDCode ? selectedICDCode.id : null,
			evisitId
		};
		axios.post('/evisit_diagnoses', diagnosis)
			.then(() => {
				this.props.onSave();
			});
	}

	render() {
		const { onClose } = this.props;
		const { icdSuggestions, icdValue, procedureSuggestions, procedureValue } = this.state;
		return (
			<div className="form-horizontal">
				<fieldset>
					<legend>Add Diagnosis</legend>
					<div className="form-group mb">
						<label className="col-sm-2 control-label">Diagnosis Code</label>
						<AutoSuggest
							suggestions={icdSuggestions}
							onSuggestionsFetchRequested={this.handleICDCodeSuggestionsFetchRequested}
							onSuggestionsClearRequested={() => this.setState({ icdSuggestions: [] })}
							onSuggestionSelected={this.handleICDCodeSelected}
							getSuggestionValue={icdCode => icdCode.icd_code}
							renderSuggestion={IcdSuggestion}
							inputProps={{
								placeholder: 'Type to choose ICD Code',
								onChange: this.handleICDCodeChange,
								value: icdValue
							}}
							theme={{
								container: 'col-sm-10',
								suggestionsContainerOpen: 'open',
								input: 'form-control',
								suggestionsList: 'dropdown-menu ml-lg mr-lg'
							}}
						/>
					</div>

					<div className="form-group mb">
						<label className="col-sm-2 control-label">Procedure</label>
						<AutoSuggest
							suggestions={procedureSuggestions}
							onSuggestionsFetchRequested={this.handleProcedureCodeSuggestionsFetchRequested}
							onSuggestionsClearRequested={() => this.setState({ procedureSuggestions: [] })}
							onSuggestionSelected={this.handleProcedureCodeSelected}
							getSuggestionValue={procedure => procedure.procedure_code}
							renderSuggestion={ProcedureSuggestion}
							inputProps={{
								placeholder: 'Type to choose Procedure Code',
								onChange: this.handleProcedureCodeChange,
								value: procedureValue
							}}
							theme={{
								container: 'col-sm-10',
								suggestionsContainerOpen: 'open',
								input: 'form-control',
								suggestionsList: 'dropdown-menu ml-lg mr-lg'
							}}
						/>
					</div>

					<div className="row">
						<div className="col-sm-offset-2 col-sm-10">
							<button type="button" className="btn btn-default mr-sm" onClick={onClose}>Cancel</button>
							<button type="button" className="btn btn-primary" onClick={this.handleSave}>Save Diagnosis</button>
						</div>
					</div>
				</fieldset>
			</div>
		);
	}
}
